import {createRouter, createWebHistory} from "vue-router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import HomeView from "../views/client/HomeView.vue";
import markets from "../views/client/marketsView.vue";
import market from "../views/client/singleMarket.vue";
import menu from "../views/client/menueView.vue";
import reserve from "../views/client/reserveView.vue";
import cart from "../views/client/cartView.vue";
import complete from "../views/client/completeOrder.vue";
import login from "../views/client/loginView.vue";
import register from "../views/client/registerView.vue";
import completeReserve from "../views/client/completeReserve.vue";
import offers from "../views/client/offersView.vue";
import forgetPassword from "../views/client/forgetPassword.vue";
import resetPassword from "../views/client/resetPassword.vue";
import profile from "../views/client/profileView.vue";
import privacy from "../views/client/privacyView.vue";
import terms from "../views/client/termsConditionView.vue";
import us from "../views/client/whoUsView.vue";
import contact from "../views/client/contactUS.vue";
import changePassword from "../views/client/changePassword.vue";
import orders from "../views/client/ordersView.vue";
import points from "../views/client/pointsView.vue";
import reservations from "../views/client/reservationsView.vue";
import reservationDetails from "../views/client/rerservationDetails.vue";
import orderDetails from "../views/client/orderDetails.vue";
import notification from "../views/client/notificationView.vue";
import partner from "../views/vendor/joinPartener.vue";

const routes = [
	{
		path: "/",
		component: DefaultLayout,
		children: [
			{
				path: "",
				name: "home",
				component: HomeView,
			},
			{
				path: "markets",
				name: "markets",
				component: markets,
			},
			{
				path: "market/:id",
				name: "market",
				component: market,
			},
			{
				path: "menu/:id",
				name: "menu",
				component: menu,
			},
			{
				path: "reserve",
				name: "reserve",
				component: reserve,
			},
			{
				path: "cart",
				name: "cart",
				component: cart,
				meta: {requiresAuth: true},
			},
			{
				path: "complete",
				name: "complete",
				component: complete,
				meta: {requiresAuth: true},
			},
			{
				path: "offers",
				name: "offers",
				component: offers,
			},
			{
				path: "profile",
				name: "profile",
				component: profile,
				meta: {requiresAuth: true},
			},
			{
				path: "terms",
				name: "terms",
				component: terms,
			},
			{
				path: "privacy",
				name: "privacy",
				component: privacy,
			},
			{
				path: "contact",
				name: "contact",
				component: contact,
			},
			{
				path: "us",
				name: "us",
				component: us,
			},
			{
				path: "orders",
				name: "orders",
				component: orders,
				meta: {requiresAuth: true},
			},
			{
				path: "points",
				name: "points",
				component: points,
				meta: {requiresAuth: true},
			},
			{
				path: "reservations",
				name: "reservations",
				component: reservations,
				meta: {requiresAuth: true},
			},
			{
				path: "orderDetails/:id",
				name: "orderDetails",
				component: orderDetails,
				meta: {requiresAuth: true},
			},
			{
				path: "reservationDetails/:id",
				name: "reservationDetails",
				component: reservationDetails,
				meta: {requiresAuth: true},
			},
			{
				path: "notification",
				name: "notification",
				component: notification,
				meta: {requiresAuth: true},
			},
			{
				path: "/completeReserve/:id",
				name: "completeReserve",
				component: completeReserve,
				meta: {requiresAuth: true},
			},
			{
				path: "/partner",
				name: "partner",
				component: partner,
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: login,
	},
	{
		path: "/register",
		name: "register",
		component: register,
	},
	{
		path: "/forgetPassword",
		name: "forgetPassword",
		component: forgetPassword,
	},
	{
		path: "/resetPassword",
		name: "resetPassword",
		component: resetPassword,
	},
	{
		path: "/changePassword",
		name: "changePassword",
		component: changePassword,
		meta: {requiresAuth: true},
	},
	{
		path: "/:pathMatch(.*)*",
		name: "notFound",
		component: () => import("../views/NotFound.vue"),
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		const token = localStorage.getItem("token");
		if (!token) {
			next({name: "login"});
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router;
